(function(document, window, undefined) {
	
	const defaultOptions = {
	  timeout: 5000,
	  jsonpCallback: 'callback',
	  jsonpCallbackFunction: null,
	};

	function generateCallbackFunction() {
	  return `jsonp_${Date.now()}_${Math.ceil(Math.random() * 100000)}`;
	}

	function clearFunction(functionName) {
	  // IE8 throws an exception when you try to delete a property on window
	  // http://stackoverflow.com/a/1824228/751089
	  try {
	    delete window[functionName];
	  } catch (e) {
	    window[functionName] = undefined;
	  }
	}

	function removeScript(scriptId) {
	  const script = document.getElementById(scriptId);
	  if (script) {
	    document.getElementsByTagName('head')[0].removeChild(script);
	  }
	}

	function fetchJsonp(_url, options = {}) {
	  // to avoid param reassign
	  let url = _url;
	  const timeout = options.timeout || defaultOptions.timeout;
	  const jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

	  let timeoutId;

	  return new Promise((resolve, reject) => {
	    const callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	    const scriptId = `${jsonpCallback}_${callbackFunction}`;

	    window[callbackFunction] = (response) => {
	      resolve({
	        ok: true,
	        // keep consistent with fetch API
	        json: () => Promise.resolve(response),
	      });

	      if (timeoutId) clearTimeout(timeoutId);

	      removeScript(scriptId);

	      clearFunction(callbackFunction);
	    };

	    // Check if the user set their own params, and if not add a ? to start a list of params
	    url += (url.indexOf('?') === -1) ? '?' : '&';

	    const jsonpScript = document.createElement('script');
	    jsonpScript.setAttribute('src', `${url}${jsonpCallback}=${callbackFunction}`);
	    if (options.charset) {
	      jsonpScript.setAttribute('charset', options.charset);
	    }
	    if (options.nonce) {
	      jsonpScript.setAttribute('nonce', options.nonce);
	    }
	    if (options.referrerPolicy) {
	      jsonpScript.setAttribute('referrerPolicy', options.referrerPolicy);
	    }
	    if (options.crossorigin) {
	      jsonpScript.setAttribute('crossorigin', 'true');
	    }
	    jsonpScript.id = scriptId;
	    document.getElementsByTagName('head')[0].appendChild(jsonpScript);

	    timeoutId = setTimeout(() => {
	      reject(new Error(`JSONP request to ${_url} timed out`));

	      clearFunction(callbackFunction);
	      removeScript(scriptId);
	      window[callbackFunction] = () => {
	        clearFunction(callbackFunction);
	      };
	    }, timeout);

	    // Caught if got 404/500
	    jsonpScript.onerror = () => {
	      reject(new Error(`JSONP request to ${_url} failed`));

	      clearFunction(callbackFunction);
	      removeScript(scriptId);
	      if (timeoutId) clearTimeout(timeoutId);
	    };
	  });
	}
	
	window.IPRedirect = {
		init: function(settings) {
			// Assignment
			var self = this;

			self.settings = JSON.parse(settings);
			
			self.catchAllCountries = self.settings["redirect_catch_all_countries"];
			self.catchAllURL = self.settings["redirect_catch_all_url"];
			self.catchAllName = self.settings["redirect_catch_all_name"];
			self.ipWhiteList = self.settings["ip_white_list"];
			self.relativeRedirect = self.settings["redirect_relative"] ? true : false;
			self.redirects = self.settings["redirects"];

			self.urlMap = {};
			self.location = {};

			// Preparation
			self.mapURLs(self.redirects, "::");
			self.redirect = (typeof self.redirect == "string") ? JSON.parse(self.redirect) : {shown: false, date: null};

			// Initialization successful
			return true;
		},
		getQueryVariable: function(variable) {
			var self = this;

			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i=0;i<vars.length;i++) {
				var pair = vars[i].split("=");
				if (pair[0] == variable) {
					return pair[1];
				}
			};
			return(false);
		},
		run: function() {
			var self = this;
			self.makeServerCall( self.fetchLocationInfoAndRunCallback );
			
		},
		mapURLs: function(stringList, splitter) {
			var self = this;

			if (self.catchAllCountries.length > 0) {
				var countries = self.catchAllCountries.split(/[\s,]+/);
				for (var i = 0; i < countries.length; ++i) {
					self.urlMap[ countries[i] ] = {
						"name": self.catchAllName,
						"url": self.catchAllURL
					}
				}
			}

			return self.urlMap;
		},
		makeServerCall: function( serverCall, callback ) {
			return serverCall(callback);
		},
		fetchLocationInfoAndRunCallback: async function() {
			var self = IPRedirect;
			fetchJsonp('https://reallyfreegeoip.org/json/', {
				jsonpCallbackFunction: 'fetchAndRedirectOnResponse'
			}).then(function(response) {
		      return response.json()
		    }).then(function(json) {
				self.fetchAndRedirectOnResponse(json)
		    }).catch(function(ex) {
		      console.log('parsing failed', ex)
		    });
		},
		fetchAndRedirectOnResponse: function( location ) {
			var self = IPRedirect;
			var ipWhiteList = self.ipWhiteList;

			var botPattern = "(googlebot\/|Googlebot-Mobile|Chrome-Lighthouse|Googlebot-Image|Google favicon|Mediapartners-Google|AdsBot-Google-Mobile|AdsBot-Google|AdsBot-Google-Mobile-Apps|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
			var re = new RegExp(botPattern, 'i');
			var userAgent = navigator.userAgent;

			self.location = location;

			if (!re.test(userAgent)) {
				if (ipWhiteList.indexOf(location.ip) == -1) {
					if (self.urlMap[location.country_code] != null) {
						if (self.urlMap[location.country_code].url != null) {
							if (self.relativeRedirect) {
								window.top.location.assign((self.urlMap[location.country_code].url + window.location.pathname + window.location.search).replace('/en-au',''));
							} else {
								window.top.location.assign(self.urlMap[location.country_code].url);
							}
						}
					}
				};
			};
		}
	};
})(document, window);